import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "villageTripsMap",
  ref: "mapContainer"
}
const _hoisted_2 = { class: "tripsCarousel" }
const _hoisted_3 = { class: "tripsSlideContent" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "villageTripTitle" }
const _hoisted_6 = { class: "villageTripStars" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "(4.5)", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cordova_map = _resolveComponent("cordova-map")!
  const _component_web_map = _resolveComponent("web-map")!
  const _component_stars = _resolveComponent("stars")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper_container = _resolveComponent("swiper-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showMap)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.$store.state.isCordova)
            ? (_openBlock(), _createBlock(_component_cordova_map, {
                key: 0,
                userPosition: _ctx.userPosition,
                center: _ctx.center,
                markers: _ctx.markers,
                onMarkerClick: _ctx.onMarkerClick
              }, null, 8, ["userPosition", "center", "markers", "onMarkerClick"]))
            : (_openBlock(), _createBlock(_component_web_map, {
                key: 1,
                userPosition: _ctx.userPosition,
                center: _ctx.center,
                markers: _ctx.markers,
                onMarkerClick: _ctx.onMarkerClick
              }, null, 8, ["userPosition", "center", "markers", "onMarkerClick"]))
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_swiper_container, {
        class: "tripsSwiper",
        autoHeight: "true",
        "slides-per-view": "auto",
        "centered-slides": "true",
        "space-between": "0",
        ref: "tripsSwiperContainer",
        onSwiperslidechange: _ctx.onSlideChange
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markers, (item, i) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              class: "tripsSwiperSlide",
              key: i,
              onClick: ($event: any) => (_ctx.$router.push('/village/escursioni/' + item.identifier))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["ribbon", item.category])
                  }, _toDisplayString(item.category), 3),
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      src: item.image.publicUrl
                    }, null, 8, _hoisted_4)
                  ]),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(item.title.values[_ctx.$store.state.selectedLanguage]), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_stars, {
                      value: 4.5,
                      size: 12
                    }, null, 8, ["value"]),
                    _createTextVNode(),
                    _hoisted_7
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["onSwiperslidechange"])
    ])
  ], 512))
}